package at.apa.statistictracker.data.model

import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@OptIn(ExperimentalJsExport::class)
@JsExport
enum class Platform {
    ANDROID,
    IOS,
    WEB
}